<template>

    <transition name="fade">
        <div class="hint-popup category-hint" v-if="visible">
            <div class="arrow-top"></div>
            <div class="content">
                <div class="close-btn" @click="close"></div>
                <p class="text">{{ t.__('Edytuj nazwę oraz ikonę kategorii') }}</p>
                <img src="/assets/images/category-hint.svg" alt="">
                <div class="progress-bar">
                    <div></div>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>

export default {

    name: 'MyQuizzesCategoryHint',

    data() {
        return {
            eventHub: window.eventHub,
            visible: false
        }
    },

    created() {
        setTimeout(() => this.show(), 1000);
    },


    methods:  {

        show() {
            this.visible = true;
            setTimeout(() => this.close(), 15000)
        },

        close() {
            this.visible = false;
        }

    }

}

</script>

<style scoped>

</style>
